module.exports = __webpack_public_path__ + "media/2x/B-803d55c5.png";